import { trackConversion } from './reddit-pixel';
import { trackGaConversion } from './ga';
import { getStashedReferralCode } from '../services/referral.service';

/**
 * Fire the sign_up conversion pair (Reddit + GA4) for a NEWLY created account.
 * Social callers gate on the backend's is_new signal — only the server knows
 * whether an OAuth pass created the account, and a login must never count.
 * from_guest completes the guest funnel started by the landing ClickPreview
 * event (GA4 owns the rate — it has the denominator). Reddit doesn't get the
 * param: its pixel only supports fixed fields, not arbitrary properties.
 * Wrapped so a tracking-side failure can never surface as an auth error.
 */
export function trackSignupConversion(
  method: 'email' | 'google' | 'apple',
  fromGuest: boolean,
  referred?: boolean,
): void {
  try {
    trackConversion('SignUp');
    // `referred` marks arrived-via-invite-link (?ref=CODE). EVERY caller now
    // captures and passes it explicitly BEFORE clearing the stash — this
    // fallback is a belt for future call sites only. It cannot be relied on:
    // the OAuth paths clear the stash before tracking fires, which is exactly
    // how referred OAuth signups silently reported false for a month
    // (Codex P2 on #818; the comment here used to claim the opposite).
    trackGaConversion('sign_up', {
      method,
      from_guest: fromGuest,
      referred: referred ?? !!getStashedReferralCode(),
    });
  } catch (err) {
    console.error('Failed to track SignUp conversion:', err);
  }
}
